var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "53px",
    height: "28px",
    viewBox: "0 0 53 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kiosko",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "configuraci\\xF3n",
    transform: "translate(-1451, -1146)",
    fill: "#0E1D25",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(1451, 1146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4744208,28 C26.1418919,28 25.8093629,27.8710866 25.5791506,27.6132597 L0,1.8305709 L1.81611969,0 L26.5,24.8802947 L51.1838803,0 L53,1.8305709 L27.4208494,27.6132597 C27.1394788,27.8710866 26.8069498,28 26.4744208,28 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.2b5907cae992d15e8315b6167a4c366b.svg";
export { ForwardRef as ReactComponent };